import {
  ACTION_EDIT_SITE_TEXTS__SUCCESS,
  ACTION_EDIT_SITE_TEXTS__REQUEST,
  ACTION_EDIT_SITE_TEXTS__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_EDIT_SITE_TEXTS__REQUEST:
    case ACTION_EDIT_SITE_TEXTS__SUCCESS:
      return null;

    case ACTION_EDIT_SITE_TEXTS__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
